import Axios from "axios";


const axiosInstance = Axios.create({
    baseURL: '',
    timeout: 20000,
    headers: { "Content-Type": 'application/json' },
});

export const setBaseURL = (url) => {
    axiosInstance.defaults.baseURL = url;
};

export const setHeaderToken = (token) => {
    if (token){
        axiosInstance.defaults.headers = {...axiosInstance.defaults.headers, Authorization:token};
    }
    else {
        delete axiosInstance.defaults.headers['Authorization'];
    }
};

export default axiosInstance;

